import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { CSSProperties, ReactNode } from "react";

interface HelloBarProps {
  children: ReactNode;
  className?: string;
  dataTestId?: string;
  exitText?: ReactNode;
  onExit?: () => void;
  style?: CSSProperties;
}

export const HelloBar = ({
  children,
  className,
  onExit,
  exitText,
  dataTestId = "trial-banner",
  style,
}: HelloBarProps) => (
  <div
    id={dataTestId}
    style={style}
    className={classNames(
      "bg-banner text-badge z-[3] hidden h-12 w-full items-center justify-center p-3 text-center font-semibold leading-5 lg:flex",
      { relative: !!exitText },
      className,
    )}
  >
    {children}
    {exitText && (
      <div className="absolute right-5">
        <button type="submit" onClick={onExit}>
          {exitText}
        </button>
      </div>
    )}
  </div>
);
